export interface ReleaseNote {
  id: string;              // sortable ISO date string, e.g. '2026-07-06'; also used as the display date
  title: string;
  body: string | string[]; // a plain paragraph, or an array of bullet points
}

// How to add a new release note:
// - Add a new entry to the TOP of this array with a unique, strictly
//   increasing `id`. Using today's date as an ISO string ('YYYY-MM-DD') is the
//   easiest way to guarantee that, since string comparison of ISO dates sorts
//   the same as chronological order.
// - `title` and `body` should be short and written for shop customers/employees,
//   not developers — no ticket numbers, internal names, or technical jargon.
// - `body` is either a single paragraph string, or an array of strings rendered
//   as a bullet list — use the array form when a release includes multiple
//   unrelated changes. For example:
//     body: ['Faster search', 'Better filters', 'Fixed a display bug']
export const RELEASE_NOTES: ReleaseNote[] = [
  {
    id: '2026-07-07',
    title: 'Release 2026.07.07',
    body: [
      'Added the ability to display release notes specific to Tire Finder',
      'Added the ability to set a preferred brand by clicking the star next to the brand name in settings. This is then filterable on results under the Specials tab',
      'Added speeds to the speed rating filter',
      'Updated the mileage warranty filter to be a range slider'
    ],
  },
  {
    id: '2026-10-06',
    title: 'Release 2026.10.06',
    body: [
      'Added the ability to include notes when sharing compare items',
      'Distributor MAP pricing is now shown where available',
      'Added progress while inventory search loads',
      'General bug fixes and maintenance'
    ],
  },
].reverse();
